"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MainHeader = void 0;
var core_1 = require("@material-ui/core");
var core_2 = require("@material-ui/core");
var react_1 = __importDefault(require("react"));
var SvgIcon_1 = require("../SvgIcon");
var MainHeader = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    var sections = _a.sections;
    var renderIcon = function (position, type) {
        var _a, _b;
        var icon;
        if (position === 'left') {
            switch (type) {
                case 'location':
                    icon = react_1.default.createElement(SvgIcon_1.LocationPhone, { style: { width: '30px', height: '30px' } });
                    break;
                case 'leftArrow':
                    icon = react_1.default.createElement(SvgIcon_1.LeftArrow, null);
                    break;
                case 'close':
                    icon = react_1.default.createElement(SvgIcon_1.Close, null);
                    break;
                default:
                    icon = react_1.default.createElement(SvgIcon_1.LeftArrow, null);
                    break;
            }
        }
        else {
            switch (type) {
                case 'more':
                    icon = react_1.default.createElement(SvgIcon_1.MoreHoriz, null);
                    break;
                case 'cart':
                    icon = ((_a = sections === null || sections === void 0 ? void 0 : sections.right) === null || _a === void 0 ? void 0 : _a.value) ? (react_1.default.createElement(core_1.Badge, { badgeContent: (_b = sections === null || sections === void 0 ? void 0 : sections.right) === null || _b === void 0 ? void 0 : _b.value, color: "primary" },
                        react_1.default.createElement(SvgIcon_1.Cart, null))) : (react_1.default.createElement(SvgIcon_1.Cart, null));
                    break;
                default:
                    icon = null;
                    break;
            }
        }
        return icon;
    };
    return (react_1.default.createElement("div", { className: "main-header ".concat(((_b = sections === null || sections === void 0 ? void 0 : sections.header) === null || _b === void 0 ? void 0 : _b.headerMode) === 'secondary' && 'rm-header') },
        react_1.default.createElement(core_2.AppBar, __assign({ position: (_d = (_c = sections === null || sections === void 0 ? void 0 : sections.header) === null || _c === void 0 ? void 0 : _c.props) === null || _d === void 0 ? void 0 : _d.position }, (_e = sections === null || sections === void 0 ? void 0 : sections.header) === null || _e === void 0 ? void 0 : _e.props),
            react_1.default.createElement(core_2.Toolbar, null,
                react_1.default.createElement("div", { className: "flex-space flex-width" },
                    ((_f = sections === null || sections === void 0 ? void 0 : sections.header) === null || _f === void 0 ? void 0 : _f.headerMode) === 'primary' && (react_1.default.createElement(SvgIcon_1.BlackLogo, { width: 150 })),
                    (sections === null || sections === void 0 ? void 0 : sections.left) && (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(core_2.IconButton, __assign({ "aria-label": "menu", className: "left-button" }, sections === null || sections === void 0 ? void 0 : sections.left.props), renderIcon('left', (_g = sections === null || sections === void 0 ? void 0 : sections.left) === null || _g === void 0 ? void 0 : _g.icon)),
                        react_1.default.createElement("span", { className: "title text" }, (_h = sections === null || sections === void 0 ? void 0 : sections.left) === null || _h === void 0 ? void 0 : _h.title)))),
                (sections === null || sections === void 0 ? void 0 : sections.right) && (react_1.default.createElement(core_2.IconButton, __assign({ "aria-label": "menu", className: "right-button ".concat(((_j = sections === null || sections === void 0 ? void 0 : sections.right) === null || _j === void 0 ? void 0 : _j.icon) === 'more' && 'more-icon') }, (_k = sections === null || sections === void 0 ? void 0 : sections.right) === null || _k === void 0 ? void 0 : _k.props), renderIcon('right', (_l = sections === null || sections === void 0 ? void 0 : sections.right) === null || _l === void 0 ? void 0 : _l.icon)))))));
};
exports.MainHeader = MainHeader;
//# sourceMappingURL=MainHeader.js.map